module.exports = __webpack_public_path__ + "img/1250.d26e1050.png";